import { DTO__workspace_child_enity } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/dto_workspace_child_enity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ICollection } from './ICollection';

export class DTO__collection extends DTO__workspace_child_enity implements ICollection {
  /*
   *
   */
  static _class_name_static: string = ENUM__dto_class_name.COLLECTION;

  /*
   * FIELDS
   */

  /*
   * METHODS
   */
}
